const quickLinks = t => ({
  new: [
    {
      id: 1,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 1
      }),
      link: 'menziller/yeni-tikili/1-otaqli'
    },
    {
      id: 2,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 2
      }),
      link: 'menziller/yeni-tikili/2-otaqli'
    },
    {
      id: 3,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 3
      }),
      link: 'menziller/yeni-tikili/3-otaqli'
    },
    {
      id: 4,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 4
      }),
      link: 'menziller/yeni-tikili/4-otaqli'
    },
    {
      id: 5,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 5
      }),
      link: 'menziller/yeni-tikili/5-otaqli'
    }
  ],
  secondary: [
    {
      id: 1,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 1
      }),
      link: 'menziller/kohne-tikili/1-otaqli'
    },
    {
      id: 2,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 2
      }),
      link: 'menziller/kohne-tikili/2-otaqli'
    },
    {
      id: 3,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 3
      }),
      link: 'menziller/kohne-tikili/3-otaqli'
    },
    {
      id: 4,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 4
      }),
      link: 'menziller/kohne-tikili/4-otaqli'
    },
    {
      id: 5,
      translates: t('quick_links.room_count', {
        postProcess: 'interval',
        count: 5
      }),
      link: 'menziller/kohne-tikili/5-otaqli'
    }
  ],
  estate: [
    {
      id: 1,
      translates: t('quick_links.houses'),
      link: 'evler'
    },
    {
      id: 2,
      translates: t('quick_links.cottages'),
      link: 'baglar'
    },
    {
      id: 3,
      translates: t('quick_links.plots'),
      link: 'torpaq'
    },
    {
      id: 4,
      translates: t('quick_links.objects'),
      link: 'obyektler'
    },
    {
      id: 5,
      translates: t('quick_links.garages'),
      link: 'qarajlar'
    },
    {
      id: 6,
      translates: t('quick_links.offices'),
      link: 'ofisler'
    }
  ]
});

export default quickLinks;
